import { TermsAndConditionsPage } from "@/common/components/terms-and-conditions/TermsAndConditionsPage";
import { PAGE_TITLE } from "@/common/constants/constants";
import Head from "next/head";

const TermsAndConditions = () => {
  return (
    <>
      <Head>
        <title>{PAGE_TITLE.TERMS_AND_CONDITIONS}</title>
        <meta name="description" content="JozyJobs app" />
      </Head>
      <TermsAndConditionsPage />
    </>
  );
};
export default TermsAndConditions;
